import {
  getSubscriptionUrl as commonsGetSubscriptionUrl,
  getAuthRedirectUrl as commonsGetAuthRedirectUrl,
  getApiAuthOptions as commonsGetApiAuthOptions,
  getEnvironment
} from '@demo-system/commons/service/environment';

const API_ROOT = process.env.REACT_APP_API_ROOT;
const ACCESS_TOKEN = process.env.REACT_APP_DEV_TOKEN;

const authProvider = (
  process.env.REACT_APP_AUTH_PROVIDER || 'ims'
).toLowerCase();

const oktaRedirectURLs = {
  test: process.env.REACT_APP_OKTA_TEST_REDIRECT,
  prod: process.env.REACT_APP_OKTA_PROD_REDIRECT
};

const imsClientIds = {
  test: process.env.REACT_APP_IMS_TEST_CLIENT,
  stage: process.env.REACT_APP_IMS_STAGE_CLIENT,
  prod: process.env.REACT_APP_IMS_PROD_CLIENT
};

const imsRedirectUris = {
  test: process.env.REACT_APP_IMS_TEST_REDIRECT_URI,
  stage: process.env.REACT_APP_IMS_STAGE_REDIRECT_URI,
  prod: process.env.REACT_APP_IMS_PROD_REDIRECT_URI
};

const subscriptionEndpoints = {
  localhost: process.env.REACT_APP_DEV_SUBSCRIPTION_URL,
  test: process.env.REACT_APP_TEST_SUBSCRIPTION_URL,
  stage: process.env.REACT_APP_STAGE_SUBSCRIPTION_URL,
  prod: process.env.REACT_APP_PROD_SUBSCRIPTION_URL
};

const builderURLs = {
  localhost: 'http://localhost:3002',
  test: 'https://dsn-test.adobe.com',
  stage: 'https://dsn-stage.adobe.com',
  prod: 'https://dsn.adobe.com'
};

const homeUrls = {
  localhost: 'http://localhost:3000',
  test: 'https://dsn-test.adobe.com',
  stage: 'https://dsn-stage.adobe.com',
  prod: 'https://dsn.adobe.com'
};

// public per-env livedemos base URLs, selected at runtime by hostname
const livedemosUrls = {
  localhost: 'https://dev.livedemos.adobe.com',
  test: 'https://dev.livedemos.adobe.com',
  stage: 'https://stage.livedemos.adobe.com',
  prod: 'https://livedemos.adobe.com'
};

const getLivedemosWorkspacesUrl = () =>
  livedemosUrls[getEnvironment()] || livedemosUrls.prod;

const getAuthRedirectUrl = () =>
  commonsGetAuthRedirectUrl({
    authProvider,
    oktaRedirectURLs,
    imsClientIds,
    imsRedirectUris,
    imsInstance: process.env.REACT_APP_IMS_INSTANCE
  });

const getBuilderURL = () => {
  const environment = getEnvironment();
  return builderURLs[environment] || builderURLs.prod;
};

const getHomeUrl = () => {
  const environment = getEnvironment();
  return homeUrls[environment] || homeUrls.prod;
};

const getSubscriptionUrl = () =>
  commonsGetSubscriptionUrl(subscriptionEndpoints);

const getApiAuthOptions = () => commonsGetApiAuthOptions(ACCESS_TOKEN);

export {
  getEnvironment,
  getAuthRedirectUrl,
  getBuilderURL,
  getHomeUrl,
  getSubscriptionUrl,
  getApiAuthOptions,
  getLivedemosWorkspacesUrl,
  API_ROOT,
  ACCESS_TOKEN
};
